<template>
    <div v-if="relationshipForm" class="py-8">
        <Card>
            <template #content>
                <CompanyRelationshipPropertiesForm
                    :form="relationshipForm"
                    :available-companies="companiesStore.getCompanyOptions"
                    @on-save="saveRelationship"
                    @on-delete="confirmDelete"
                    :disabled="!$auth.hasPermission('create:company-relationships')"
                />
            </template>
        </Card>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useCompanyRelationshipsStore } from "@/stores/companyRelationships.js";
import { useCompaniesStore } from "@/stores/companies.js";
import CompanyRelationshipPropertiesForm from "@/Forms/CompanyRelationship/CompanyRelationshipPropertiesForm.vue";

export default {
    name: "CompanyRelationshipPropertiesView",
    components: { CompanyRelationshipPropertiesForm },
    props: {
        relationship: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            relationshipForm: undefined,
        };
    },
    emits: [
        'on-save',
        'on-delete',
    ],
    computed: {
        ...mapStores(useCompanyRelationshipsStore, useCompaniesStore),
    },
    methods: {
        async saveRelationship() {
            try {
                const response = await this.relationshipForm.submit();
                this.$toast.add({
                    severity: 'success',
                    summary: this.$t('common.complete'),
                    detail: this.$t('pages.admin.companies.relationships.relationship.properties.company_relationship_properties_view.relationship_saved'),
                    life: 3000,
                });
                this.$emit('on-save');
                this.$router.replace({
                    name: 'admin.companies.relationships.relationship',
                    params: { ...this.$route.params, relationship: response.data.id },
                });
            } catch (error) {
                // Errors are handled by the form
            }
        },
        confirmDelete() {
            this.$confirm.require({
                group: 'delete',
                message: this.$t('pages.admin.companies.relationships.relationship.properties.company_relationship_properties_view.are_you_sure_you_want_to_delete_this_relationship'),
                header: this.$t('pages.admin.companies.relationships.relationship.properties.company_relationship_properties_view.delete_relationship'),
                accept: () => {
                    this.deleteRelationship();
                },
                reject: () => {
                    this.$toast.add({
                        severity: 'info',
                        summary: this.$t('common.cancelled'),
                        detail: this.$t('pages.admin.companies.relationships.relationship.properties.company_relationship_properties_view.relationship_was_not_deleted'),
                        life: 3000,
                    });
                },
            });
        },
        async deleteRelationship() {
            try {
                if (this.$route.params.relationship !== 'NEW') {
                    await this.companyRelationshipsStore.deleteCompanyRelationship(this.$route.params.relationship);
                    this.$emit('on-delete');
                }
                this.$router.push({
                    name: 'admin.companies.relationships',
                    params: { ...this.$route.params, relationship: undefined },
                });
            } catch (error) {
                // Error already handled
            }
        },
    },
    watch: {
        '$route.params.relationship': {
            async handler(newValue) {
                if (newValue) {
                    await this.companiesStore.indexCompanyOptions();

                    if (this.$route.params.relationship === 'NEW') {
                        this.relationshipForm = await this.companyRelationshipsStore.createCompanyRelationship();
                    } else {
                        this.relationshipForm = await this.companyRelationshipsStore.editCompanyRelationship(this.$route.params.relationship);
                        this.relationshipForm.id = this.$route.params.relationship;
                    }
                } else {
                    this.relationshipForm = undefined;
                }
            },
            immediate: true,
        },
    },
};
</script>

<style scoped>
</style>
